const places = {
  estaciones_names: {
    value: 'Estaciones de metro',
    icon: 'bus-stop',
  },
  restaurantes_names: {
    value: 'Restaurantes',
    icon: 'silverware-fork-knife',
  },
  veterinarias_names: {
    value: 'Veterinarias',
    icon: 'dog',
  },
  vegano_names: {
    value: 'Restaurantes veganos',
    icon: 'carrot',
  },
  universidades_names: {
    value: 'Universidades',
    icon: 'school',
  },
  terrapuertos_names: {
    value: 'Terminales terrestres',
    icon: 'bus-double-decker',
  },
  supermercados_names: {
    value: 'Supermercados',
    icon: 'cart',
  },
  parques_names: {
    value: 'Parques',
    icon: 'tree',
  },
  mall_names: {
    value: 'Centros comerciales',
    icon: 'shopping',
  },
  hospitales_names: {
    value: 'Hospitales',
    icon: 'hospital-building',
  },
  gimnasios_names: {
    value: 'Gimnasios',
    icon: 'weight-lifter',
  },
  guarderias_names: {
    value: 'Guardería',
    icon: 'baby-carriage',
  },
  schools_names: {
    value: 'Colegios',
    icon: 'book-open-page-variant',
  },
  clinicas_names: {
    value: 'Clínicas',
    icon: 'hospital-box',
  },
  cines_names: {
    value: 'Cines',
    icon: 'theater',
  },
  canchas_names: {
    value: 'Canchas',
    icon: 'soccer-field',
  },
  bancos_names: {
    value: 'Bancos',
    icon: 'piggy-bank',
  },
};

export default places;
